<template>
	<div class="sa-flexbox">
		<div class="sa-flexbox-header">
			<div class="sa-page-search-component">
				<b-form style="width: 100%" @submit.prevent="onClickDescrizioneFarmaco">
					<b-row class="sa-form-btn-filter">
						<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
							<!-- <label class="sa-label-data">Nome Commerciale</label> -->
							<div class="sa-page-search-component-wrapper">
								<input class="sa-page-search-component-input" v-model="filtroFarmaci.descrizione" placeholder="Nome Commerciale..." />

								<button class="sa-page-search-component-btn-search" title="Nome Articolo">
									<i class="fas fa-search"></i>
								</button>
							</div>
						</b-col>
						<b-col cols="12" xs="12" sm="12" md="6" lg="3" xl="3">
							<!-- <label class="sa-label-data">Codice A.I.C.</label> -->
							<div class="sa-page-search-component-wrapper">
								<input class="sa-page-search-component-input" v-model="filtroFarmaci.codiceProdotto" placeholder="Codice A.I.C...." />

								<button class="sa-page-search-component-btn-search" title="Nome Articolo">
									<i class="fas fa-search"></i>
								</button>
							</div>
						</b-col>
						<b-col cols="12" xs="12" sm="12" md="6" lg="3" xl="3">
							<!-- <label class="sa-label-data">Codice A.T.C</label> -->
							<div class="sa-page-search-component-wrapper">
								<input class="sa-page-search-component-input" v-model="filtroFarmaci.atcGmp" placeholder="Codice A.T.C..." />

								<button class="sa-page-search-component-btn-search" title="Nome Articolo">
									<i class="fas fa-search"></i>
								</button>
							</div>
						</b-col>
					</b-row>
				</b-form>
			</div>
			<!-- <b-form @submit.prevent="onClickDescrizioneFarmaco">
				<b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
					<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
						<label class="sa-label-data">Nome Commerciale:</label>
						<b-form-input class="text-uppercase" v-model="filtroFarmaci.descrizione" :placeholder="this.$i18n.t('therapy.lblDrug')"></b-form-input>
					</b-col>
					<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
						<label class="sa-label-data">Codice A.I.C.:</label>
						<b-form-input maxlength="16" class="text-uppercase" v-model="filtroFarmaci.codiceProdotto" placeholder="A.I.C."></b-form-input>
					</b-col>
					<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
						<label class="sa-label-data">Codice A.T.C.:</label>
						<b-form-input maxlength="16" class="text-uppercase" v-model="filtroFarmaci.atcGmp" placeholder="A.T.C."></b-form-input>
					</b-col>
				</b-row>
				<b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
					<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
						<b-button type="submit" variant="info"><b-icon icon="search"></b-icon> {{ this.$i18n.t("patients.lblFind") }}</b-button>
					</b-col>
				</b-row>
			</b-form> -->
		</div>
		<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
			<b-col lg="3">
				<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
			</b-col>
			<b-col lg="9">
				<b-pagination v-model="page" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
			</b-col>
		</b-row>
		<div class="sa-flexbox-body">
			<div class="b-table-sticky-header">
				<b-table id="tabellaFarmaci" :busy="isBusy" sticky-header stacked="lg" striped hover :items="itemsFarmaci" :fields="fieldsFarmaci" :current-page="1" selectable select-mode="single" @row-selected="onRowSelectedFarmaco" sort-icon-left head-variant="light" class="sa-b-table">
					<template #table-busy>
						<div class="text-center text-danger my-2">
							<b-spinner class="align-middle"></b-spinner>
							<strong style="padding-left: 10px">Caricamento dati in corso...</strong>
						</div>
					</template>
					<template #cell(index)="row">
						<span> {{ (page - 1) * perPage + row.index + 1 }} </span>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-flexbox-footer">
			<div class="sa-flexbox-footer-bar">
				<div class="sa-flexbox-footer-bar-separator"></div>
				<div class="sa-flexbox-footer-bar-element"><b-button size="sm" variant="outline-danger" @click="onClickChiudi()">Annulla Selezione</b-button></div>
				<div class="sa-flexbox-footer-bar-element"><b-button size="sm" variant="outline-success" @click="onClickConferma()" :disabled="isBusy">Conferma Selezione</b-button></div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
export default {
	data() {
		return {
			pathResourceFarmaci: "/farmaci",
			filtroFarmaci: { descrizione: null, aicCode: null, page: null, forPage: null },
			rows: 0,
			page: 1,
			perPage: 100,
			farmacoSelezionato: null,
			schedaFarmaco: null,
			isBusy: false,
			itemsFarmaci: [],
			fieldsFarmaci: [
				{
					label: "*",
					key: "index",
					thStyle: "width: 0.5rem",
				},
				{
					label: "Nome Farmaco",
					key: "descrizione",
					sortable: true,
				},
				{
					label: "A.I.C,",
					key: "codiceProdotto",
					sortable: true,
					thStyle: "width: 7rem",
				},
				{
					label: "ATC",
					key: "atcGmp",
					sortable: true,
					thStyle: "width: 7rem",
				},
				{
					label: "Prezzo",
					key: "euroPrezzo1",
					sortable: true,
					thStyle: "width: 7rem",
					formatter: (value) => value.toLocaleString("it-IT", { style: "currency", currency: "EUR" }),
					// formatter: function (value) {
					//     return value;
					// },
				},
			],
		};
	},
	watch: {
		page() {
			let me = this;
			me.ricercaFarmaco();
		},
	},
	methods: {
		onRowSelectedFarmaco(item) {
			let me = this;
			console.log(item);
			if (item.length > 0) {
				me.farmacoSelezionato = item[0];
			}
		},
		onClickChiudi() {
			this.$emit("annullaSelezione");
		},
		onClickConferma() {
			this.$emit("confermaSelezione", this.farmacoSelezionato);
		},
		onClickDescrizioneFarmaco() {
			let me = this;
			me.ricercaFarmaco();
		},
		ricercaFarmaco() {
			let me = this;
			me.isBusy = true;
			me.filtroFarmaci.page = me.page;
			me.filtroFarmaci.forPage = me.perPage;
			let link = process.env.VUE_APP_PATH_API + me.pathResourceFarmaci;
			axios.get(link, { params: this.filtroFarmaci })
				.then((response) => {
					me.itemsFarmaci = response.data.data.list;
					me.rows = response.data.data.list.length;
					me.isBusy = false;
				})
				.catch((error) => {
					me.itemsFarmaci = [];
					me.isBusy = false;
					me.$bvModal
						.msgBoxOk(error.response.data.messaggio, {
							title: "ATTENZIONE",
							size: "sm",
							okVariant: "outline-danger",
							headerClass: "sa-msg-header-danger",
							footerClass: "p-2 border-top-0",
							centered: true,
						})
						.then((value) => {
							this.boxTwo = value;
						})
						.catch((error) => {
							console.log(error);
						});
				});
		},
	},
};
</script>

<style lang="scss" scoped></style>
